import * as React from 'react';
import { SVGProps } from 'react';

const IconNodesSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M4 5a1 1 0 0 0-1 1v2a4 4 0 1 1 0 8v2a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1v-2a4 4 0 0 1 0-8V6a1 1 0 0 0-1-1H4z" />
    <path d="M23 12a2 2 0 1 1-4 0 2 2 0 0 1 4 0zM3 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4z" />
  </svg>
);
export default IconNodesSizeM;
